/**
 * Preferencia de la barra lateral (contraída o desplegada).
 *
 * El menú del panel se contrae a iconos en escritorio y el usuario espera
 * encontrarlo igual al volver: por eso el estado se guarda y se lee al arrancar,
 * sin parpadeo, en el mismo almacén que el resto de preferencias del panel.
 */

import { useCallback, useEffect, useState } from 'react';

import { storage } from '@/lib/storage';

const CLAVE = 'menu-contraido';

/** ¿El menú quedó contraído la última vez? */
export function useMenuLateral(): {
  contraido: boolean;
  alternar: () => void;
} {
  const [contraido, setContraido] = useState(() => storage.getRaw(CLAVE) === '1');

  useEffect(() => {
    storage.setRaw(CLAVE, contraido ? '1' : '0');
  }, [contraido]);

  const alternar = useCallback(() => setContraido((previo) => !previo), []);

  return { contraido, alternar };
}
